/**
 * Sdílená paleta avatarových gradientů.
 * Reused v MojeSmena/ShiftHeader, Flotila dlaždicích, Řidiči gridu.
 * Deterministicky mapuje ID na gradient, takže stejný uživatel má všude
 * stejné barvy.
 */
export const AVATAR_GRADIENTS = [
    ['#6C4192', '#975ACD'], // purple
    ['#FF8A00', '#FFB347'], // orange
    ['#0CC0DF', '#5DCAA5'], // teal-green
    ['#EF4444', '#F59E0B'], // red-orange
    ['#10B981', '#0CC0DF'], // green-teal
    ['#8B5CF6', '#EC4899'], // violet-pink
];

export function gradientFor(id) {
    const idx = Math.abs(Number(id || 0)) % AVATAR_GRADIENTS.length;
    return AVATAR_GRADIENTS[idx];
}

export function gradientCssFor(id) {
    const [c1, c2] = gradientFor(id);
    return `linear-gradient(135deg, ${c1}, ${c2})`;
}

export function initials(jmeno, prijmeni) {
    const a = (jmeno || '').trim()[0] || '';
    const b = (prijmeni || '').trim()[0] || '';
    return (a + b).toUpperCase() || '—';
}
